"use strict";
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ApplicationInsights = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _applicationinsightsReactJs = require("@microsoft/applicationinsights-react-js");
var _applicationinsightsWeb = require("@microsoft/applicationinsights-web");
var _EventEmitter = require("../internal/EventEmitter");
var _printWarningWithTrace = require("../internal/printWarningWithTrace");
var _pageViewInitializer = require("../internal/telemetry/browser/pageViewInitializer");
var _createFilterTelemetryProcessor = require("../internal/telemetry/createFilterTelemetryProcessor");
var _createFixedRateSampler = require("../internal/telemetry/createFixedRateSampler");
var _enhanceDependencyDataProcessor = require("../internal/telemetry/server/enhanceDependencyDataProcessor");
var _excludeHealthProbesTelemetryProcessor = require("../internal/telemetry/server/excludeHealthProbesTelemetryProcessor");
var _excludeNextjsTelemetryProcessor = require("../internal/telemetry/server/excludeNextjsTelemetryProcessor");
var _excludeSwaggerTelemetryProcessor = require("../internal/telemetry/server/excludeSwaggerTelemetryProcessor");
var _ApplicationInsightsNotInitializedError = require("./ApplicationInsightsNotInitializedError");
var _isServerApplicationInsightsClient = require("./isServerApplicationInsightsClient");
var ApplicationInsights = /*#__PURE__*/ function() {
    function ApplicationInsights() {
        _class_call_check(this, ApplicationInsights);
    }
    _create_class(ApplicationInsights, null, [
        {
            key: "_reset",
            value: /**
   * Destroys internal Application Insights, DO NOT USE OUTSIDE OF @ori/logger
   *
   * @internal
   */ function _reset() {
                this.realApplicationInsights = null;
            }
        },
        {
            key: "get",
            value: /**
   * Returns Application Insights if its initialized, othervise throws
   *
   * @throws ApplicationInsightsNotInitializedError Application Insights must be initialized
   */ function get() {
                var value = this.realApplicationInsights;
                if (!value) {
                    throw new _ApplicationInsightsNotInitializedError.ApplicationInsightsNotInitializedError();
                }
                return value;
            }
        },
        {
            key: "getForClient",
            value: /**
   * Gets you typed client-side Application Insights
   */ function getForClient() {
                var value = this.get();
                if ((0, _isServerApplicationInsightsClient.isServerApplicationInsightsClient)(value)) {
                    throw new Error('Cannot get Application Insights for client, because getForClient was probably called on server');
                }
                return value;
            }
        },
        {
            key: "getForServer",
            value: /**
   * Gets you typed server-side Application Insights
   */ function getForServer() {
                var value = this.get();
                if (!(0, _isServerApplicationInsightsClient.isServerApplicationInsightsClient)(value)) {
                    throw new Error('Cannot get Application Insights for server, because getForServer was probably called on client');
                }
                return value;
            }
        },
        {
            key: "onInitialized",
            value: /**
   * Attaches listener that lets you listen for event when application insights was created for environment.
   *
   * This allows you to make changes on application insights before first log is send to application insights itself
   *
   * @param listener
   */ function onInitialized(listener) {
                var _this = this;
                var eventListener = function(param) {
                    var instance = param.instance;
                    listener(instance);
                };
                // If its initialized already then we need invoke listener rightaway
                if (this.isInitialized()) {
                    eventListener({
                        instance: this.get()
                    });
                }
                this.eventEmitter.addListener('created', eventListener);
                return {
                    /**
       * Removes listener
       */ remove: function() {
                        return _this.eventEmitter.removeListener('created', eventListener);
                    }
                };
            }
        },
        {
            key: "isInitialized",
            value: /**
   * Checks if Application Insights is initialized
   */ function isInitialized() {
                return !!this.realApplicationInsights;
            }
        },
        {
            key: "initialize",
            value: /**
   * Initializes application insights for current environment and attaches it to this.
   * If it is already initialized then in will just return without doing anything.
   *
   * Automatic `pageView` tracking is disabled to prevent `pageView` from being sent multiple times.
   * See the example how to track `pageView`:
   * @example
   * import { ApplicationInsights } from '@ori/logger';
   * ApplicationInsights.trackPageView();
   */ function initialize(input) {
                if (this.isInitialized()) {
                    return;
                }
                var fallbackOptions = global.oriAppInsightsSettings;
                var _ref;
                var options = (_ref = input !== null && input !== void 0 ? input : fallbackOptions) !== null && _ref !== void 0 ? _ref : {};
                var connectionString = options.connectionString, _options_samplingPercentage = options.samplingPercentage, samplingPercentage = _options_samplingPercentage === void 0 ? 100 : _options_samplingPercentage;
                if (!connectionString) {
                    // TODO (OL): Should we do some checking to hide this warning when certain environment variable is provided?
                    // eslint-disable-next-line no-console -- we want to use native console instead
                    console.warn('Could not initialize Application Insights due to missing connectionString');
                    return;
                }
                // @ts-expect-error -- okay for here
                var isInEdgeRuntime = typeof EdgeRuntime === 'string';
                if (typeof window === 'undefined' && !isInEdgeRuntime) {
                    var isMainThread = // eslint-disable-next-line node/global-require, @typescript-eslint/no-require-imports -- caller is not async
                    require('node:worker_threads').isMainThread;
                    var serverApplicationInsights = // This is manily for edge where edge will throw that it cannot find application insights
                    // and it will keep the sync import of module on server where we should no await import of application insights
                    // eslint-disable-next-line node/global-require, @typescript-eslint/no-require-imports -- Explanation on the previous line
                    require('applicationinsights');
                    serverApplicationInsights.setup(connectionString).setAutoCollectExceptions(isMainThread).setSendLiveMetrics(isMainThread).setAutoCollectConsole(false).setAutoCollectRequests(false) // is handled by our appshell-server
                    .setAutoCollectPerformance(isMainThread).setAutoDependencyCorrelation(isMainThread).setAutoCollectIncomingRequestAzureFunctions(isMainThread);
                    serverApplicationInsights.start();
                    serverApplicationInsights.defaultClient.addTelemetryProcessor(_excludeHealthProbesTelemetryProcessor.excludeHealthProbesTelemetryProcessor);
                    serverApplicationInsights.defaultClient.addTelemetryProcessor(_excludeNextjsTelemetryProcessor.excludeNextjsTelemetryProcessor);
                    serverApplicationInsights.defaultClient.addTelemetryProcessor(_excludeSwaggerTelemetryProcessor.excludeSwaggerTelemetryProcessor);
                    serverApplicationInsights.defaultClient.addTelemetryProcessor(_enhanceDependencyDataProcessor.enhanceDependencyDataProcessor);
                    serverApplicationInsights.defaultClient.config.samplingPercentage = samplingPercentage;
                    this.realApplicationInsights = serverApplicationInsights;
                } else {
                    // browserHistory.location.pathname = browserHistory.state.url
                    var config = _object_spread_props(_object_spread({}, options), {
                        samplingPercentage: samplingPercentage,
                        extensions: [],
                        extensionConfig: {}
                    });
                    if (!isInEdgeRuntime) {
                        var browserHistory = _object_spread({
                            url: '',
                            location: {
                                pathname: ''
                            },
                            listen: function() {}
                        }, window.history);
                        var reactPlugin = new _applicationinsightsReactJs.ReactPlugin();
                        config.extensions.push(reactPlugin);
                        config.extensionConfig[reactPlugin.identifier] = {
                            history: browserHistory
                        };
                    }
                    var applicationInsights = new _applicationinsightsWeb.ApplicationInsights({
                        config: config
                    });
                    // Enable Beacon API and disable XHR to try avoid double telemetry
                    applicationInsights.config.isBeaconApiDisabled = false;
                    applicationInsights.config.disableXhr = true;
                    applicationInsights.loadAppInsights();
                    applicationInsights.addTelemetryInitializer(_pageViewInitializer.pageViewInitializer);
                    applicationInsights.addTelemetryInitializer((0, _createFilterTelemetryProcessor.createFilterTelemetryProcessor)(function(envelope) {
                        var _envelope_data;
                        return ((_envelope_data = envelope.data) === null || _envelope_data === void 0 ? void 0 : _envelope_data.baseType) === 'MetricData' && [
                            'LCP',
                            'CLS',
                            'INP'
                        ].includes(envelope.name);
                    }, (0, _createFixedRateSampler.createFixedRateSampler)(10)));
                    if (!isInEdgeRuntime) {
                        window.appInsights = applicationInsights;
                        var flushAppInsights = function() {
                            try {
                                applicationInsights.flush();
                            } catch (e) {
                            // Suppress flush errors during unload — can safely fail if not yet initialized
                            }
                        };
                        window.addEventListener('beforeunload', flushAppInsights);
                        window.addEventListener('pagehide', flushAppInsights);
                    }
                    this.realApplicationInsights = applicationInsights;
                }
                var loggerDebugIsEnabled = process.env.DEBUG_LOGGER === 'true';
                if (loggerDebugIsEnabled) {
                    (0, _printWarningWithTrace.printWarningWithTrace)('AppInsights initialized');
                }
                this.eventEmitter.emit('created', {
                    instance: this.realApplicationInsights
                });
            }
        }
    ]);
    return ApplicationInsights;
}();
exports.ApplicationInsights = ApplicationInsights;
(0, _defineProperty2.default)(ApplicationInsights, "realApplicationInsights", null);
(0, _defineProperty2.default)(ApplicationInsights, "eventEmitter", new _EventEmitter.EventEmitter()); //# sourceMappingURL=ApplicationInsights.js.map
